// extracted by mini-css-extract-plugin
export default {"SurveyRecordsList":"SurveyRecordsList_SurveyRecordsList__LYseT","MobileView":"SurveyRecordsList_MobileView__5DRFk","Pagination":"SurveyRecordsList_Pagination__g5a36"};